import { FC } from 'react'
import { useAppSelector } from '../../store/hooks'
import { Cluster as ClusterModel } from '../../models/Cluster'
import { selectClusterById } from '../../store/ClusterReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'

type Props = SBModelComponent<ClusterModel> & {}

const ClusterOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectClusterById(id!))

  if (!item) {
    return <></>
  }

  return item.name
}

type ClusterOptionType = { Option: typeof ClusterOption }

export { ClusterOption, type ClusterOptionType }
